import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export default function useRecaptchaAction() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getRecaptchaPayload = async (action) => {
    if (!executeRecaptcha) {
      throw new Error("reCAPTCHA has not loaded yet");
    }

    const token = await executeRecaptcha(action);

    if (!token) {
      throw new Error("Failed to retrieve reCAPTCHA token");
    }

    return {
      recaptchaToken: token,
      recaptchaAction: action,
    };
  };

  return { getRecaptchaPayload };
}
